import React from 'react';
import styled from 'styled-components';

const StyledArrowIcon = styled.svg`
	stroke: initial !important;
`;

const ArrowIcon = ({ className = '', position = 'right' }) => {
	return (
		<StyledArrowIcon
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
		>
			<g clipPath='url(#clip0_256_12)'>
				{position === 'left' ? (
					<path
						d='M16.6667 9.16665H6.52504L11.1834 4.50831L10 3.33331L3.33337 9.99998L10 16.6666L11.175 15.4916L6.52504 10.8333H16.6667V9.16665Z'
						fill='#545454'
					/>
				) : (
					<path
						d='M9.99989 3.33334L8.82489 4.50834L13.4749 9.16668H3.33322V10.8333H13.4749L8.82489 15.4917L9.99989 16.6667L16.6666 10L9.99989 3.33334Z'
						fill='#545454'
					/>
				)}
			</g>
			<defs>
				<clipPath id='clip0_256_12'>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</StyledArrowIcon>
	);
};

export default ArrowIcon;
